import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

function ClickLabel({ x, y, value }) {
  if (!value || value <= 0) return null;
  return (
    <text x={x} y={y - 10} fill="#22c55e" fontSize={11} fontWeight="bold" textAnchor="middle">
      {value}
    </text>
  );
}

export default function GSCChart({ data }) {
  if (!data || data.length < 2) {
    return (
      <div className="bg-dark-300 border border-dark-50 rounded-xl p-5 text-center text-gray-500 py-12">
        Not enough data for chart
      </div>
    );
  }

  const chartData = data.map((d) => ({
    date: new Date(d.date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    }),
    impressions: d.impressions,
    clicks: d.clicks,
  }));

  return (
    <div className="bg-dark-300 border border-dark-50 rounded-xl p-5">
      <h3 className="text-sm font-semibold text-gray-300 mb-4">
        Impressions &amp; Clicks Over Time
      </h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
            <XAxis
              dataKey="date"
              tick={{ fill: "#64748b", fontSize: 11 }}
              axisLine={{ stroke: "#1e293b" }}
            />
            <YAxis
              tick={{ fill: "#64748b", fontSize: 11 }}
              axisLine={{ stroke: "#1e293b" }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "#111827",
                border: "1px solid #1e293b",
                borderRadius: "8px",
                fontSize: "12px",
              }}
            />
            <Legend wrapperStyle={{ fontSize: "12px", color: "#94a3b8" }} />
            <Line
              type="monotone"
              dataKey="impressions"
              stroke="#b87333"
              strokeWidth={2}
              dot={false}
              name="Impressions"
            />
            <Line
              type="monotone"
              dataKey="clicks"
              stroke="#22c55e"
              strokeWidth={2}
              dot={(props) => {
                const { cx, cy, payload } = props;
                if (!payload.clicks || payload.clicks <= 0) return null;
                return <circle cx={cx} cy={cy} r={4} fill="#22c55e" stroke="#22c55e" />;
              }}
              label={<ClickLabel />}
              name="Clicks"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
